import { forwardRef } from 'react';
import { ReactKit } from '@team/react';
import { Appearance } from '../../../../services/appearance';
import { RootComponent } from '../../../../services/root-component';
import { Caption } from '../../../../typography/caption';
import { Button } from '../../../../blocks/button';
import { BasicProps } from '../../types';
import { LogLevel } from '../../enums';
import css from './style.module.css';

export const Layout = forwardRef<HTMLDivElement, BasicProps>(function Component(
  {
    logLevel = LogLevel.LOG,
    before,
    children,
    description,
    link,
    action,
    onActionClick,
    ...props
  },
  forwardedRef
) {
  return (
    <Appearance type="light">
      <RootComponent
        {...props}
        Component="div"
        baseClassName={css.root}
        role={logLevel}
        ref={forwardedRef}
      >
        <div className={css.inner}>
          {ReactKit.hasNode(before) && (
            <div className={css.before}>{before}</div>
          )}

          <div className={css.main}>
            <Caption level={1} weight={2}>
              {children}
            </Caption>

            {ReactKit.hasNode(description) && (
              <Caption level={1} weight={3}>
                {description}
              </Caption>
            )}

            {ReactKit.hasNode(link) && (
              <Caption level={1} weight={3} className={css.link}>
                {link}
              </Caption>
            )}
          </div>

          {ReactKit.hasNode(action) && (
            <div className={css.after}>
              <Button
                className={css.action}
                mode="link"
                size="l"
                onClick={onActionClick}
              >
                {action}
              </Button>
            </div>
          )}
        </div>
      </RootComponent>
    </Appearance>
  );
});
